export default function NumberFormat(number, isCurrency = false, decimalPlaces = 2) {
    if(!isCurrency)
        return new Intl.NumberFormat('en-US').format(number);
    else
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);
}